import { useCallback } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import deleteAsset from 'asset-actions-lib/api/deleteAsset';
import { getName } from 'asset-actions-lib/utils/crmObject';
import { ACTION_IDS } from 'asset-actions-lib/constants/actionIds';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DeleteModal({
  onClose,
  onConfirm,
  crmObject
}) {
  const {
    onActionError
  } = useAssetActions();
  const {
    objectTypeId
  } = crmObject;
  const assetName = getName(crmObject);
  const handleDelete = useCallback(() => {
    deleteAsset(crmObject).then(() => {
      onConfirm(ACTION_IDS.DELETE, crmObject);
    }).catch(() => {
      if (onActionError) {
        onActionError({
          actionId: ACTION_IDS.DELETE,
          data: crmObject
        });
      }
    });
  }, [crmObject, onActionError, onConfirm]);
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    "data-test-id": "delete-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `assetActionsLib.modals.delete.${objectTypeId}.header`
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `assetActionsLib.modals.delete.${objectTypeId}.body`,
        options: {
          assetName
        }
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "danger",
        onClick: handleDelete,
        "data-test-id": "delete-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `assetActionsLib.modals.delete.${objectTypeId}.confirmButton`
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLib.modals.shared.cancelButton"
        })
      })]
    })]
  });
}